<div class="page">
  <app-page-site-switcher *ngIf="false"></app-page-site-switcher>
  <div class="page-grid">
    <section class="card">
      <div class="card__body">

        @if (loading()) {
          <p class="loading-state">{{ 'formulaire.loading' | translate }}</p>
        }

        <div class="columns" [class.hidden]="loading()">

          <!-- Colonne gauche : liste des pages (1/3) -->
          <div class="col-pages">
            <div class="add-page-row">
              <input
                type="text"
                class="page-name-input"
                [placeholder]="'formulaire.pageNamePlaceholderFr' | translate"
                [(ngModel)]="newPageName"
                (keydown.enter)="addPage()"
              />
              <button type="button" class="btn-add-page" (click)="addPage()" [disabled]="!newPageName.trim()">
                + {{ 'formulaire.addPage' | translate }}
              </button>
            </div>
            <span class="validation-hint" *ngIf="pageNameError">{{ pageNameError }}</span>
            <span class="char-count" [class.warn]="newPageName.length > maxPageNameLength - 10" [class.over]="newPageName.length > maxPageNameLength" *ngIf="newPageName.length > 0">{{ newPageName.length }}/{{ maxPageNameLength }}</span>

            <!-- Champs i18n pour nouvelle page -->
            @for (lang of secondaryLangs; track lang) {
              <input
                type="text"
                class="page-name-input i18n-input"
                [placeholder]="'formulaire.pageNamePlaceholderLang' | translate: { lang: langLabel(lang) }"
                [dir]="lang === 'ar' ? 'rtl' : 'ltr'"
                [(ngModel)]="newPageNameI18n[lang]"
              />
            }

            <div class="pages-list">
              @if (pages().length === 0) {
                <p class="empty-placeholder">{{ 'formulaire.noPage' | translate }}</p>
              } @else {
                @for (page of pages(); track page.id; let i = $index) {
                  <div
                    class="page-item"
                    [class.selected]="selectedIndex() === i"
                    (click)="selectPage(i)"
                  >
                    <span class="page-item-name">{{ page.name }}</span>
                    <button
                      type="button"
                      class="btn-danger-chip"
                      (click)="$event.stopPropagation(); removePage(i)"
                    >
                      <svg class="icon-16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                    </button>
                  </div>
                }
              }
            </div>
          </div>

          <!-- Colonne droite : questions (2/3) -->
          <div class="col-questions">
            @if (selectedPage(); as page) {
              <div class="questions-panel">

                <!-- Nom de la page éditable -->
                <div class="questions-header">
                  <input
                    type="text"
                    class="page-name-input"
                    [placeholder]="'formulaire.pageNamePlaceholderFr' | translate"
                    [ngModel]="page.name"
                    (ngModelChange)="updatePageName($event)"
                  />
                  @for (lang of secondaryLangs; track lang) {
                    <input
                      type="text"
                      class="page-name-input i18n-input"
                      [placeholder]="'formulaire.pageNamePlaceholderLang' | translate: { lang: langLabel(lang) }"
                      [dir]="lang === 'ar' ? 'rtl' : 'ltr'"
                      [ngModel]="currentPageNameI18n[lang] || ''"
                      (ngModelChange)="updatePageNameI18n(lang, $event)"
                    />
                  }
                </div>

                <!-- Ajout d'une question -->
                <div class="add-question-row">
                  <input
                    type="text"
                    class="page-name-input"
                    [placeholder]="'formulaire.questionPlaceholderFr' | translate"
                    [(ngModel)]="newQuestion"
                    (keydown.enter)="addQuestion()"
                  />
                  <button type="button" class="btn-add-page" (click)="addQuestion()" [disabled]="!newQuestion.trim()">
                    + {{ 'formulaire.addQuestion' | translate }}
                  </button>
                </div>
                <span class="validation-hint" *ngIf="questionError">{{ questionError }}</span>
                <span class="char-count" [class.warn]="newQuestion.length > maxQuestionLength - 20" [class.over]="newQuestion.length > maxQuestionLength" *ngIf="newQuestion.length > 0">{{ newQuestion.length }}/{{ maxQuestionLength }}</span>

                @for (lang of secondaryLangs; track lang) {
                  <input
                    type="text"
                    class="page-name-input i18n-input"
                    [placeholder]="'formulaire.questionPlaceholderLang' | translate: { lang: langLabel(lang) }"
                    [dir]="lang === 'ar' ? 'rtl' : 'ltr'"
                    [(ngModel)]="newQuestionI18n[lang]"
                  />
                }

                <!-- Liste des questions -->
                <div class="questions-list">
                  @if (page.questions.length === 0) {
                    <p class="empty-placeholder">{{ 'formulaire.noQuestion' | translate }}</p>
                  } @else {
                    @for (q of page.questions; track q.id; let qi = $index) {
                      <div class="question-item">
                        <div class="question-texts">
                          <span class="question-text">{{ q.text }}</span>
                          @for (lang of secondaryLangs; track lang) {
                            <span class="question-text-i18n" [dir]="lang === 'ar' ? 'rtl' : 'ltr'">
                              {{ parseI18n(q.textI18n)[lang] || '' }}
                            </span>
                          }
                        </div>
                        <button type="button" class="btn-danger-chip" (click)="removeQuestion(qi)">
                          <svg class="icon-16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                        </button>
                      </div>
                    }
                  }
                </div>
              </div>
            } @else {
              <div class="questions-empty-state">
                <p>{{ 'formulaire.selectPageHint' | translate }}</p>
              </div>
            }
          </div>

        </div>
      </div>
    </section>
  </div>
</div>

<!-- Confirmation suppression page -->
@if (pendingDeletePage() !== null) {
  <app-confirm-modal
    [title]="'formulaire.confirmDeletePage.title' | translate"
    [message]="('formulaire.confirmDeletePage.message' | translate: { name: pages()[pendingDeletePage()!].name })"
    [confirmText]="'formulaire.confirmDeletePage.confirmText' | translate"
    [cancelText]="'formulaire.confirmDeletePage.cancelText' | translate"
    (confirm)="confirmDeletePage()"
    (cancel)="cancelDeletePage()"
  />
}

<!-- Confirmation suppression question -->
@if (pendingDeleteQuestion() !== null) {
  <app-confirm-modal
    [title]="'formulaire.confirmDeleteQuestion.title' | translate"
    [message]="'formulaire.confirmDeleteQuestion.message' | translate"
    [confirmText]="'formulaire.confirmDeleteQuestion.confirmText' | translate"
    [cancelText]="'formulaire.confirmDeleteQuestion.cancelText' | translate"
    (confirm)="confirmDeleteQuestion()"
    (cancel)="cancelDeleteQuestion()"
  />
}